module.exports = __webpack_public_path__ + "static/media/hn.57160f53.svg";